'use client'

import PropTypes from 'prop-types'
import MUITextField from '@mui/material/TextField'
import MUITypography from '@mui/material/Typography'
import MUIButton from '@mui/material/Button'
import MUIMenu from '@mui/material/Menu'
import MUIMenuItem from '@mui/material/MenuItem'
import MUIIconButton from '@mui/material/IconButton'
import MUITooltip from '@mui/material/Tooltip'
import { AddIcon } from '@repo/ui/AddIcon'
import { ReplaceIcon } from '@repo/ui/ReplaceIcon'
import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import { useState, useEffect } from 'react'
import { useTimeRecordingStore } from '@repo/store/useTimeRecordingStore'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'

export const AttendanceNoteEntry = ({ workflowTypeId, testData = null, value = '', onChange }) => {
  const { fetchAttendanceText, attendanceTextOptions } = useTimeRecordingStore()
  const { isOutlookAddin } = useGlobalSettingsStore()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const [options, setOptions] = useState(testData || attendanceTextOptions || [])

  useEffect(() => {
    if (testData) return
    setOptions(attendanceTextOptions || [])
  }, [testData, attendanceTextOptions])

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const addStandardNote = (note, method) => {
    let attendanceNote = value

    if (method === 'replace') {
      attendanceNote = note
    } else if (method === 'append') {
      const prefix = value ? `${value}\n\n` : ''
      attendanceNote = `${prefix}${note}`
    }

    closeMenu()
    if (onChange) onChange(attendanceNote)
  }

  useEffect(() => {
    if (testData || !workflowTypeId) return
    fetchAttendanceText({ workflowTypeId })
  }, [testData, workflowTypeId, fetchAttendanceText])

  return (
    <div
      style={{ position: 'relative', width: '100%', minWidth: isOutlookAddin ? 0 : '396px' }}
      data-testid="AttendanceNoteEntry"
    >
      <MUITextField
        multiline
        minRows={12}
        sx={{ width: '100%', '.MuiInputBase-root': { paddingTop: '80px' } }}
        value={value}
        placeholder="Attendance note"
        onChange={(e) => onChange(e.target.value)}
      />
      <hr
        style={{
          left: '12px',
          top: '60px',
          width: 'calc(100% - 24px)',
          position: 'absolute',
          margin: 0,
          borderColor: '#051C331F'
        }}
      />

      <MUIButton
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disabled={!workflowTypeId || !options?.length}
        onClick={openMenu}
        sx={{ position: 'absolute', top: '12px', left: '12px', textTransform: 'none' }}
      >
        <AddIcon sx={{ color: '#3D517B8F', marginRight: '8px', width: '24px', height: '24px' }} />
        Add standard note
        <ChevronRightIcon
          sx={{
            transform: `rotate(${open ? '-' : ''}90deg)`,
            marginTop: '1px',
            transition: 'all 250ms',
            color: '#3D517B8F'
          }}
        />
      </MUIButton>

      <MUIMenu anchorEl={anchorEl} open={open} onClose={closeMenu} sx={{ zIndex: 99999 }}>
        {options.map((option) => {
          return (
            <MUIMenuItem sx={{ width: '100%', minWidth: '388px', pr: 0 }} key={option.attendanceTextId}>
              <MUITypography
                variant="body1"
                sx={{
                  mb: 0,
                  cursor: 'pointer',
                  flex: 1,
                  maxWidth: '300px',
                  textWrap: 'wrap',
                  minHeight: '36px',
                  padding: '8px 4px 8px 0px'
                }}
                onClick={() => addStandardNote(option.attendanceNote, 'append')}
              >
                {option.attendanceNote}
              </MUITypography>

              <MUITooltip title="Replace note" placement="top" arrow>
                <MUIIconButton onClick={() => addStandardNote(option.attendanceNote, 'replace')}>
                  <ReplaceIcon sx={{ color: '#3D517B8F', width: '18px', height: '18px' }} />
                </MUIIconButton>
              </MUITooltip>

              <MUITooltip title="Append to note" placement="top" arrow>
                <MUIIconButton onClick={() => addStandardNote(option.attendanceNote, 'append')}>
                  <AddIcon sx={{ color: '#3D517B8F', width: '18px', height: '18px' }} />
                </MUIIconButton>
              </MUITooltip>
            </MUIMenuItem>
          )
        })}
      </MUIMenu>
    </div>
  )
}

AttendanceNoteEntry.propTypes = {
  workflowTypeId: PropTypes.string,
  testData: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func
}
